<template>
  <div class="Leftnav">
    <div class="nav_title item">
      <p>{{ bigTitle }}</p>
      <h1>{{ title }}</h1>
    </div>
    <div v-for="(item, key) in list" :key="key" :v-if="isrefresh">
      <div
        :class="[
          'item',
          'item_title',
          'item_list',
          button == key ? 'active' : '',
        ]"
        @click="triggerButton(key, item)"
        :style="{ background: 'rgba(238,238,238,' + item.option + ')' }"
      >
        <p>{{ item.title }}</p>
      </div>
      <div v-if="listTitle == item.title">
        <div
          v-for="(x, index) in item.children"
          :key="index"
          :class="[
            'item',
            'children_title',
            'item_list',
            buttonChildren == index ? 'active2' : '',
          ]"
          @click="triggerButton2(x.id, index, x.year)"
          :style="{ background: 'rgba(238,238,238,' + x.option + ')' }"
        >
          <p>{{ x.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "Leftnav",
  data() {
    return {
      button: this.newData,
      buttonChildren: 0,
      listTitle: false,
      isrefresh: true,
    };
  },
  methods: {
    triggerButton(e, b) {
      this.button = e;
      if (b.title == "新闻中心") {
        this.$router.push({
          path: "/Home/homeItem4",
          query: { year: b.children[0].year },
        });
      }
      // this.listTitle = this.list[e].title;

      this.$emit("event1", this.button);
    },
    triggerButton2(id, e, year) {
      this.buttonChildren = e;
      this.$store.state.buttonChildren = id;
      this.$store.state.pageNumber = 1;
      this.$router.push({ path: "/Home/homeItem4", query: { year: year } });
    },
  },
  mounted: function () {
    if (this.list.length >= 3) {
      let arrList = this.list[3].children;
      if (arrList) {
        for (let y = 0; y < arrList.length; y++) {
          if (arrList[y].year == this.$store.state.year) {
            this.buttonChildren = y;
          }
        }
      }
    }

    if (this.$route.query.id) {
      this.button = this.$route.query.id;
    }
    //初始找子数组默认取第一个id值
    let arryList = this.list;

    for (let x = 0; x < arryList.length; x++) {
      if (arryList[x].children) {
        if (arryList[x].children.id != undefined) {
          this.$store.state.buttonChildren = arryList[x].children[0].id;
        }
      }
    }
    this.listTitle = this.list[this.button].title;
  },
  components: {},
  props: {
    list: Array,
    title: String,
    bigTitle: String,
    newData: Number,
  },
  watch: {
    newData: {
      handler: function (e) {
        this.triggerButton(e);
      },
    },
    $route: {
      handler(newRouter) {
        //字标题循环徇众找到下标，高亮显示
        let str = newRouter.fullPath;
        var index = str.lastIndexOf("=");
        str = str.substring(index + 1, str.length);
        if (this.list.length >= 3) {
          let list = this.list[3].children;
          if (list) {
            for (let y = 0; y < list.length; y++) {
              if (list[y].year == str) {
                this.buttonChildren = y;
              }
            }
          }
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped="scoped">
.Leftnav {
  width: 5.75rem;
}
.nav_title {
  width: 5.75rem;
  height: 2.5rem;
}
.nav_title p {
  font-size: 0.3375rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #9a9a9a;
}
.nav_title h1 {
  font-size: 0.55rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
}
.item {
  padding-right: 0.5875rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 3px;
  background: #eeeeee;
  /* padding-top: 0.4375rem;
  padding-bottom: 0.4375rem; */
}
.item_list {
  height: 1.25rem;
}
.item_title {
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #343434;
  cursor: pointer;
}
.children_title {
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #343434;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.children_title:hover {
  font-size: 0.475rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fffefe;
  background: #40684b !important;
  cursor: pointer;
}
.item_title:hover {
  font-size: 0.475rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fffefe;
  background: #bbb389 !important;
}
.active {
  font-size: 0.475rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fffefe;
  background: #bbb389 !important;
}
.showIn {
  display: none;
}
.item_children {
  height: 1.25rem;
  background: #40684b !important;
}
.active2 {
  font-size: 0.475rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fffefe;
  background: #40684b !important;
}
</style>